module.exports = __webpack_public_path__ + "static/media/c3-bg.7cd2fc2e.jpg";